module.exports = __webpack_public_path__ + "img/bigwin-text.ec719a23.png";